import { ApolloClient } from 'apollo-client';
import { createUploadLink } from 'apollo-upload-client/lib/main';
import { setContext } from 'apollo-link-context';
import { InMemoryCache } from 'apollo-cache-inmemory/lib';

const httpLink = createUploadLink({ url: '/graphql' });

const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem('token');
  if (token) {
    return {
      headers: {
        ...headers,
        authorization: `Bearer ${token}`,
      }
    };
  }

  return { headers };
});

const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache({
    dataIdFromObject: object => object.id,
  })
});

export default client;



// WEBPACK FOOTER //
// ./src/apollo-client.js